import { Box, Stack, Typography } from "@mui/material"
import { BlockCaption } from "components/controls/blockCaption"
import { ValueSpan } from "components/controls/valueSpan"
import { WorkerCount, WorkerCounts } from "interface/sisetu"
import { useMemo } from "react"
import { numberFormat, round } from "shared/util"

const workerCountSubTotal = (workerCount: WorkerCount) => {
  return (workerCount.fullTime ?? 0) + (workerCount.partTime ?? 0)
}
export const workerCountTotal = (workerCounts: WorkerCounts) => {
  return (
    workerCountSubTotal(workerCounts.doctor) +
    workerCountSubTotal(workerCounts.nurse) +
    workerCountSubTotal(workerCounts.pharmacist) +
    workerCountSubTotal(workerCounts.radiologicalTechnologist) +
    workerCountSubTotal(workerCounts.clinicalLaboratoryTechnician)
  )
}

type WorkerCountRecordProps = {
	label: string,
	workerCount: WorkerCount
	isSmallMedia: boolean
}
const WorkerCountRecord = ({
	label,
	workerCount,
	isSmallMedia
}: WorkerCountRecordProps) => {
	const subTotal = useMemo(
		() => workerCountSubTotal(workerCount),
		[workerCount]
	)
	if (subTotal === 0) return <></>
	return isSmallMedia ? (
		<Box>
			<BlockCaption sticky={false} caption={label} rightElement={
				<ValueSpan text={numberFormat(round(subTotal, 1))} suffix="人" align="right" textAlign="right"/>
			}/>
			<Stack direction="row" justifyContent="flex-end" alignItems="center" spacing={0.5} flexWrap="wrap" paddingX={1}>
				<Typography variant="body2" component="div" color="text.secondary">(</Typography>
				<Typography variant="body2" component="div" color="text.secondary">常勤</Typography>
				<ValueSpan text={workerCount.fullTime ? numberFormat(round(workerCount.fullTime, 1)) : '-'} suffix="人" align="right" textAlign="right" stackProps={{ minWidth: "4em" }}/>
				<Typography variant="body2" component="div" color="text.secondary">/</Typography>
				<Typography variant="body2" component="div" color="text.secondary">非常勤</Typography>
				<ValueSpan text={workerCount.partTime ? numberFormat(round(workerCount.partTime, 1)) : '-'} suffix="人" align="right" textAlign="right" stackProps={{ minWidth: "4em" }}/>
				<Typography variant="body2" component="div" color="text.secondary">)</Typography>
			</Stack>
		</Box>
	) : (
		<Stack direction="row" alignItems="center" spacing={0.5}>
			<Typography variant="body2" component="div" color="text.secondary" sx={{ minWidth: '5em' }}>{label}</Typography>
			<ValueSpan text={numberFormat(round(subTotal, 1))} suffix="人" align="right" textAlign="right" stackProps={{ minWidth: "5em" }}/>
			<Typography variant="body2" component="div" color="text.secondary">(</Typography>
			<Typography variant="body2" component="div" color="text.secondary">常勤</Typography>
			<ValueSpan text={workerCount.fullTime ? numberFormat(round(workerCount.fullTime, 1)) : '-'} suffix="人" align="right" textAlign="right" stackProps={{ minWidth: "4em" }}/>
			<Typography variant="body2" component="div" color="text.secondary">/</Typography>
			<Typography variant="body2" component="div" color="text.secondary">非常勤</Typography>
			<ValueSpan text={workerCount.partTime ? numberFormat(round(workerCount.partTime, 1)) : '-'} suffix="人" align="right" textAlign="right" stackProps={{ minWidth: "4em" }}/>
			<Typography variant="body2" component="div" color="text.secondary">)</Typography>
		</Stack>
	)
}

type WorkerCountTableProps = {
	workerCounts: WorkerCounts
	isSmallMedia: boolean
}
export const WorkerCountTable = ({
	workerCounts,
	isSmallMedia	
}: WorkerCountTableProps) => (
	<Box>
		<Stack direction="column" spacing={0.5}>
			<WorkerCountRecord isSmallMedia={isSmallMedia} workerCount={workerCounts.doctor} label='医師' />
			<WorkerCountRecord isSmallMedia={isSmallMedia} workerCount={workerCounts.nurse} label='看護師' />
			<WorkerCountRecord isSmallMedia={isSmallMedia} workerCount={workerCounts.pharmacist} label='薬剤師'/>
			<WorkerCountRecord isSmallMedia={isSmallMedia} workerCount={workerCounts.radiologicalTechnologist} label='放射線技師'/>
			<WorkerCountRecord isSmallMedia={isSmallMedia} workerCount={workerCounts.clinicalLaboratoryTechnician} label='検査技師'/>
		</Stack>
	</Box>
)
